import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";

function Preview(props) {
    
    const {lang} = useContext(GlobalContext)

    const [images, setImages] = useState([])

    const imgData = () => {
        let aux = []
        for(let i = 0; i < props.imgURL.length; i++){
            aux.push([props.imgURL[i], props.imgDesc[i]])
        }
        console.log("imgData", aux);
        setImages(aux)
    }

    if(images.length === 0){
        imgData()
    }

    console.log(props);

    return(
        <div className="preview projDet" id="preview-det">
            <h4 className="preview__link">
                {lang === "ingles" ? "See it for your self "  : "Velo tu mismo "}
                <a href={props.link}>{lang === "ingles" ? " HERE!" : " AQUÍ!"}</a>
            </h4>

            <div className="preview__images">
                {images.map((img) => {
                    console.log(img[0]);
                    return(
                        <div className="preview__imgElement">
                            <img src={img[0]} className="preview__img"/>
                            <p className="preview__imgDesc">{img[1]}</p>
                            <br />
                            <hr />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Preview